import Resource from '@/api/resources/Resource'

class ProvinceConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/provinces`, filterModel, { params })
        return response.data
    }
    async patchProvincesBatch(provinces) {
        const response = await this.axios.patch(`/configuration/provinces/batch`, provinces)
        return response.data
    }
    async createProvince(province) {
        const response = await this.axios.post(`/configuration/provinces`, province)
        return response.data
    }
    async deleteProvincesBatch(provinces) {
        const data = {
            entityIdentifiers: provinces
        }
        const response = await this.axios.delete(`/configuration/provinces/batch`, { data: data })
        return response.data
    }
}

export default new ProvinceConfigurationServices()
